import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import Item from '../item';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store';
import router from '@/router';

class Main extends BaseMinigamesMain {
  constructor() {
    super();
    const gameId = router.currentRoute.params.id;
    this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
    this.gameData = {};
    this.difficulty = 1;
    this.iteration = 0;
    this.START_Y_ASCENT = 880;
    this.START_Y_DESCENT = 510;
    this.STEP_Y = 75;
    this.ITEMS_AREA_WIDTH = 1200;
    this.ITEMS_AREA_X_OFFSET = 20;
    this.ITEMS_AREA_STEP_X = 65;
    this.ITEMS_AREA_Y = 140;
    this.platforms = [];
    this.items = [];
    this.dropZones = [];
    this.dropData = {};
    this.earthquakeTweens = [];
    this.flyTweens = [];
    this.baseGroup = null;
    this.dragGroup = null;
    this.platformGroup = null;
    this.quakeData = [];
    this.instructions = null;
  }

  create() {
    this.initialize();

    const title = this.make.text({
      x: this.game.config.width / 2,
      y: 980,
      text: this.gameConfig.titleTxt,
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        lineSpacing: 10,
      },
    });

    this.loadIteration();

    this.createBasicUI();
  }

  nextIteration() {
    this.platforms.map(x => x.destroy());
    this.platforms = [];
    this.items.map(x => x.destroyItem());
    this.items = [];
    this.baseGroup.destroy();
    this.baseGroup = null;
    this.dragGroup.destroy();
    this.dragGroup = null;
    this.platformGroup.destroy();
    this.platformGroup = null;
    this.START_Y_ASCENT = 880;
    this.START_Y_DESCENT = 510;
    this.STEP_Y = 75;
    this.ITEMS_AREA_WIDTH = 1200;
    this.ITEMS_AREA_X_OFFSET = 20;
    this.ITEMS_AREA_STEP_X = 65;
    this.ITEMS_AREA_Y = 140;
    this.dropZones = [];
    this.flyTweens = [];
    this.quakeData = [];
    this.instructions.destroy();
    this.instructions = null;
    this.iteration = this.iteration + 1;
    if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
      this.showSummary();
    } else {
      this.loadIteration();
    }
  }

  createTemplateUI() {
    this.instructions = this.make.text({
      x: this.game.config.width / 2,
      y: 10,
      text: this.gameConfig.instructionsTxt.replace(
        '${sortType}',
        this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType,
      ),
      origin: { x: 0.5, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 10,
        align: 'center',
      },
    });
  }

  loadIteration() {
    // eslint-disable-next-line max-len
    this.SLOT_WIDTH = this.game.scale.width / this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount;
    this.createPlatforms();
    this.baseGroup = this.add.container(0, 0).setDepth(1);
    this.platformGroup = this.add.container(0, 0).setDepth(1);
    this.dragGroup = this.add.container(0, 0).setDepth(1);
    const assetsData = this.gameConfig.assets.map(elem => elem);
    this.createItems(assetsData);
    this.createTemplateUI();
  }

  createPlatforms() {
    // eslint-disable-next-line max-len
    for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount; i++) {
      // eslint-disable-next-line max-len
      const y = this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING
        ? this.START_Y_ASCENT - i * this.STEP_Y
        : this.START_Y_DESCENT + i * this.STEP_Y;

      const platformContainer = this.add.container(0, y).setDepth(1);
      const platform = this.add.sprite(0, 0, 'platforms');
      platform.setFrame(0);
      platformContainer.add(platform);
      // platform.x = this.SLOT_WIDTH / 2 + i * this.SLOT_WIDTH;
      platformContainer.x = this.SLOT_WIDTH / 2 + i * this.SLOT_WIDTH;
      this.platforms.push(platformContainer);

      const zoneWidth = platform.width;
      const zoneHeight = 350;
      const zone = new Phaser.Geom.Rectangle(
        platformContainer.x - platform.width / 2,
        platformContainer.y + platform.height / 2 - zoneHeight,
        zoneWidth,
        zoneHeight,
      );
      this.dropZones.push(zone);
      this.dropData[i] = null;
      this.generateDataForEarthquake(platformContainer);
      this.generateDataForFlying(platformContainer);
    }
  }

  getRandomValueFromArray(targetArray) {
    const rndIdx = Math.floor(Math.random() * targetArray.length);
    const res = targetArray.splice(rndIdx, 1);
    return res[0];
  }

  createItems(dataArray) {
    const step = this.ITEMS_AREA_STEP_X;

    let itemsWidth = 0;
    // eslint-disable-next-line max-len
    for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount; i++) {
      const item = this.getRandomValueFromArray(dataArray);
      const itemObject = new Item(this, item.id).create();
      // eslint-disable-next-line max-len
      itemObject.setDragCallbacks(this.onDragStart.bind(this, itemObject), this.onDragStop.bind(this, itemObject));
      this.items.push(itemObject);
      itemObject.setData('value', item.id);
      itemObject.setData('platform', null);
      itemsWidth += itemObject.getData('width');
      this.baseGroup.add(itemObject.getContainer());
    }

    // eslint-disable-next-line max-len
    const globalWidth = itemsWidth + step * (this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount - 1);
    if (globalWidth > this.ITEMS_AREA_WIDTH) {
      const scale = this.ITEMS_AREA_WIDTH / globalWidth;
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].setScale(scale);
      }
    }

    // eslint-disable-next-line max-len
    const isAscending = this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING;
    // eslint-disable-next-line max-len
    itemsWidth = isAscending ? this.ITEMS_AREA_X_OFFSET : this.game.config.width - this.ITEMS_AREA_X_OFFSET;
    const y = this.ITEMS_AREA_Y;
    for (let i = 0; i < this.items.length; i++) {
      // eslint-disable-next-line max-len
      if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING) {
        this.items[i].place(itemsWidth, y);
        itemsWidth += this.items[i].getData('width') + step;
      } else {
        this.items[i].place(itemsWidth - this.items[i].getData('width'), y);
        itemsWidth -= this.items[i].getData('width') + step;
      }
    }
  }
  /**
   *
   */

  onDragStart(dragObj, pointer, x, y) {
    this.dragGroup.add(dragObj.getContainer());
    this.condenseNumbers();
  }
  /**
   *
   */

  onDragStop(dragObj, pointer) {
    for (let i = 0; i < this.dropZones.length; i++) {
      const zone = this.dropZones[i];
      let platformItemsChanged = true;
      if (zone.contains(pointer.position.x, pointer.position.y)) {
        if (this.dropData[i] !== null) {
          platformItemsChanged = false;
          const spriteOnPlatform = this.getItemByValue(this.dropData[i]);
          if (spriteOnPlatform) {
            if (dragObj.getData('platform') === null) {
              const container = spriteOnPlatform.getContainer();
              const parent = container.parentContainer;
              if (parent) {
                // swapping
                container.x = parent.x + container.x;
                container.y = parent.y + container.y;
                platformItemsChanged = true;
              }
              this.releaseItem(spriteOnPlatform);
            } else {
              const platformIdx = dragObj.getData('platform');
              if (spriteOnPlatform.getData('value') === dragObj.getData('value')) {
                const dragContainer = dragObj.getContainer();
                dragContainer.x = -dragObj.getData('width') / 2;
                dragContainer.y = -dragObj.getHeight() - 30;
                this.platforms[platformIdx].add(dragObj.getContainer());
                return;
              }
              platformItemsChanged = true;
              this.dropData[dragObj.getData('platform')] = spriteOnPlatform.getData('value');
              spriteOnPlatform.setData('platform', dragObj.getData('platform'));

              this.platforms[platformIdx].add(spriteOnPlatform.getContainer());
            }
          }
        } else if (dragObj.getData('platform') !== null) {
          platformItemsChanged = false;
          this.dropData[dragObj.getData('platform')] = null;
        }
        const dragContainer = dragObj.getContainer();
        dragContainer.x = -dragObj.getData('width') / 2;
        dragContainer.y = -dragObj.getHeight() - 30;
        dragObj.setData('platform', i);
        this.dropData[i] = dragObj.getData('value');
        this.platforms[i].add(dragContainer);
        this.checkSequence(platformItemsChanged, dragContainer);
        return;
      }
    }
    this.releaseItem(dragObj);
    this.checkSequence(false);
  }
  /**
   *
   */

  getItemByValue(value) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].getData('value') === value) {
        return this.items[i];
      }
    }
    return null;
  }

  releaseItem(numberObj) {
    this.cursorManager.resetCursor();
    let lastX = this.getLastX();
    const target = numberObj.getContainer();
    // eslint-disable-next-line max-len
    if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_DESCENDING) {
      lastX -= numberObj.getData('width');
    }

    this.tweens.add({
      targets: target,
      x: lastX,
      y: this.ITEMS_AREA_Y,
      duration: 600,
      ease: 'Quint.easeOut',
    });
    this.dropData[numberObj.getData('platform')] = null;
    numberObj.setData('platform', null);
    this.baseGroup.add(numberObj.getContainer());
  }
  /**
   *
   */

  checkSequence(isDropOnPlatform, dragObj) {
    let isDone = true;
    for (let i = 0; i < this.platforms.length; i++) {
      this.platforms[i].getAt(0).setFrame(0);
    }
    let currentValue = null;
    let breakIndex = null;
    // eslint-disable-next-line max-len
    for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount; i++) {
      if (this.dropData[i] !== null) {
        currentValue = this.dropData[i];
        // currentIndex = i;
        break;
      }
    }
    // eslint-disable-next-line max-len
    for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount; i++) {
      const value = this.dropData[i];
      if (value !== null) {
        // eslint-disable-next-line max-len
        if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING) {
          if (currentValue > value) {
            breakIndex = i;
            break;
          } else {
            currentValue = value;
            continue;
          }
        } else if (currentValue < value) {
          breakIndex = i;
          break;
        } else {
          currentValue = value;
          continue;
        }
      }
    }
    if (breakIndex !== null) {
      if (isDropOnPlatform) {
        this.playWrong();
      }
      this.showWrongPlatforms(breakIndex);
    } else if (isDropOnPlatform) {
      if (!dragObj.labeledCorrect) {
        this.playCorrect();
        dragObj.labeledCorrect = true;
      }
    }

    // eslint-disable-next-line max-len
    for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsCount; i++) {
      const value = this.dropData[i];
      if (value === null) {
        isDone = false;
      }
    }

    if (isDone && breakIndex === null) {
      setTimeout(() => {
        this.baseGroup.setDepth(0);
        this.platformGroup.setDepth(0);
        this.dragGroup.setDepth(0);
        this.platforms.map(platform => platform.setDepth(0));
        this.nextIteration();
      }, 2000);
    }
  }

  showWrongPlatforms(startIndex) {
    for (let i = 0; i < this.platforms.length; i++) {
      this.platforms[i].getAt(0).setFrame(0);
    }
    for (let i = startIndex; i < this.platforms.length; i++) {
      this.platforms[i].getAt(0).setFrame(1);
    }
    this.playEarthquake(startIndex);
  }
  /**
   *
   */

  playEarthquake(startIndex) {
    for (let i = startIndex; i < this.platforms.length; i++) {
      this.earthquake(i);
    }
  }
  /**
   *
   */

  earthquake(index) {
    const iterations = 25;
    let currentXIndex = 0;
    let currentYIndex = 0;
    const targetValues = this.quakeData[index];

    this.tweens.add({
      targets: this.platforms[index],
      x: {
        value() {
          const value = targetValues.xValues[currentXIndex];
          currentXIndex += 1;
          return value;
        },
      },
      y: {
        value() {
          const value = targetValues.yValues[currentYIndex];
          currentXIndex += 1;
          return value;
        },
      },
      duration: 1200 / iterations,
      ease: 'Linear',
      repeat: iterations,
    });
  }
  /**
   *
   */

  generateDataForEarthquake(platform) {
    const delta = 15;
    const iterations = 25;
    const direction = -1;
    const defaultX = platform.x;
    const defaultY = platform.y;
    const targetXValues = [];
    const targetYValues = [];
    for (let i = 0; i < iterations; i++) {
      const targetPoint = this.getRandomPointInRange(defaultX, defaultY, delta, direction);
      targetXValues.push(targetPoint.x);
      targetYValues.push(targetPoint.y);
    }
    targetXValues.push(defaultX);
    targetYValues.push(defaultY);

    this.quakeData.push({
      xValues: targetXValues,
      yValues: targetYValues,
    });
  }
  /**
   *
   */

  generateDataForFlying(platform) {
    const randomDistance = 10 + Math.round(Math.random() * 10);
    const randomDelay = Math.round(Math.random() * 800);
    // const randomTime = 900 + Math.round(Math.random() * 400);
    const tween = this.tweens.add({
      targets: platform,
      y: platform.y - randomDistance,
      duration: 1200,
      ease: 'Sine.easeInOut',
      repeat: -1,
      delay: randomDelay,
      yoyo: true,
    });
    this.flyTweens.push(tween);
  }
  /**
   *
   */

  condenseNumbers() {
    // eslint-disable-next-line max-len
    const isAscending = this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING;
    // eslint-disable-next-line max-len
    let targetX = isAscending ? this.ITEMS_AREA_X_OFFSET : this.game.config.width - this.ITEMS_AREA_X_OFFSET;
    for (let i = 0; i < this.baseGroup.getAll().length; i++) {
      const target = this.baseGroup.getAt(i);
      const bounds = target.getBounds();

      this.tweens.add({
        targets: target,
        x: isAscending ? targetX : targetX - bounds.width,
        duration: 600,
        ease: 'Quint.easeOut',
      });
      if (isAscending) {
        targetX += bounds.width + this.ITEMS_AREA_STEP_X;
      } else {
        targetX -= bounds.width + this.ITEMS_AREA_STEP_X;
      }
    }
  }
  /**
   *
   */

  getLastX() {
    // eslint-disable-next-line max-len
    const isAscending = this.gameConfig.sets[this.difficulty].iterations[this.iteration].sortType === EDC.SortTypes.ST_ASCENDING;
    const baseContainers = this.baseGroup.getAll();
    let lastX = 0;
    if (baseContainers.length) {
      lastX = baseContainers[0].x;
      for (let i = 0; i < baseContainers.length; i++) {
        const currentX = baseContainers[i].x;
        if (isAscending && currentX > lastX) {
          lastX = currentX;
        } else if (!isAscending && currentX < lastX) {
          lastX = currentX;
        }
      }
      const lastContainer = baseContainers[baseContainers.length - 1];
      const lastWidth = lastContainer.getBounds().width;

      // eslint-disable-next-line max-len
      lastX = isAscending ? lastX + lastWidth + this.ITEMS_AREA_STEP_X : lastX - this.ITEMS_AREA_STEP_X;
    }
    return lastX;
  }

  getRandomPointInRange(startX, startY, delta, direction) {
    const randX = startX + Math.round(Math.random() * delta) * direction;
    const randY = startY + Math.round(Math.random() * delta) * direction;
    return { x: randX, y: randY };
  }
}

export default Main;
